module.exports = __webpack_public_path__ + "img/thumb_20.a3c3ff26.jpg";